// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"b74c693d","324":"a5667701","416":"50b2298b","453":"68693753","521":"bf05d3ac","744":"68dfe97e"}[chunkId] + ".chunk.js";
};